var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "score-board py-16px py-lg-22px mx-auto",
    attrs: {
      "max-width": "1920",
      "color": "#49832E"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l(_vm.logs, function (item) {
    return [_c('div', {
      key: item,
      staticClass: "swiper-slide"
    }, [_vm._v(_vm._s(item.config.ranking) + "등 " + _vm._s(item.user.name) + " (" + _vm._s(item.user.phone) + ")")])];
  })], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }